const Corp = () => import('@/views/main/helper/corpReminder/CorpReminder.vue')
export default {
  path: '/main/corp/manage',
  name: 'Corp',
  component: Corp,
  children: []
}
